import React, { useState } from "react";
import styles from "./BookingForm.module.css";

const WHATSAPP_NUMBER = "971567575811";

function BookingForm() {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    whatsapp: "",
    date: "",
    timeSlot: "",
    guests: "",
    notes: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const message =
      `New Booking Request — Tripontourism\n\n` +
      `Name: ${form.fullName}\n` +
      `Email: ${form.email}\n` +
      `Phone: ${form.phone}\n` +
      `WhatsApp: ${form.whatsapp || form.phone}\n` +
      `Date: ${form.date}\n` +
      `Time Slot: ${form.timeSlot}\n` +
      `Guests: ${form.guests}\n` +
      (form.notes ? `Notes: ${form.notes}\n` : "");

    const link = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      message
    )}`;

    // Opens WhatsApp (app or web) with the booking details pre-filled,
    // ready for the customer to hit send to our number.
    window.open(link, "_blank", "noopener,noreferrer");
  };

  return (
    <section id="booking-form" className={styles.section}>
      <div className="container">
        <h2 className={styles.title}>Quick Booking Form</h2>
        <p className={styles.subtitle}>
          Fill in your details and we'll open WhatsApp with your booking
          request ready to send.
        </p>

        <form className={styles.form} onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-12 col-md-6">
              <input
                type="text"
                name="fullName"
                placeholder="Full Name"
                className={styles.input}
                value={form.fullName}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-12 col-md-6">
              <input
                type="email"
                name="email"
                placeholder="Email"
                className={styles.input}
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-12 col-md-6">
              <input
                type="tel"
                name="phone"
                placeholder="Phone"
                className={styles.input}
                value={form.phone}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-12 col-md-6">
              <div className={styles.inputWithIcon}>
                <input
                  type="tel"
                  name="whatsapp"
                  placeholder="WhatsApp Number"
                  className={styles.input}
                  value={form.whatsapp}
                  onChange={handleChange}
                />
                <span className={styles.whatsappIcon} aria-hidden="true">
                  💬
                </span>
              </div>
            </div>

            <div className="col-12 col-md-6">
              <input
                type="date"
                name="date"
                className={styles.input}
                value={form.date}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-12 col-md-6">
              <input
                type="time"
                name="timeSlot"
                className={styles.input}
                value={form.timeSlot}
                onChange={handleChange}
                required
              />
            </div>

            <div className="col-12 col-md-6">
              <input
                type="number"
                min="1"
                name="guests"
                placeholder="Number of Guests"
                className={styles.input}
                value={form.guests}
                onChange={handleChange}
                required
              />
            </div>
            <div className="col-12 col-md-6">
              <input
                type="text"
                name="notes"
                placeholder="Special Requests"
                className={styles.input}
                value={form.notes}
                onChange={handleChange}
              />
            </div>
          </div>

          <button type="submit" className={styles.submitBtn}>
            Send Booking via WhatsApp
          </button>
        </form>
      </div>
    </section>
  );
}

export default BookingForm;
